import React, { useState } from 'react';
import { Formik } from 'formik';
import { IconEye, IconEyeOff, IconMail, IconLock } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import SitesyncLogo from 'assets/images/logo.png';
import { useDispatch, useSelector } from 'react-redux';
import { SIGN_IN_REQUEST } from 'actions/authActions';
import withAuth from '../../hoc/withAuth';

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const authError = useSelector((state) => state.auth.error);

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          {/* Branding */}
          <div className="login-card__brand">
            <img src={SitesyncLogo} alt="SiteSync" className="login-card__logo" />
            <h1 className="login-card__title">SiteSync</h1>
            <p className="login-card__subtitle">Site commissioning made simple</p>
          </div>

          <div className="login-card__divider" />

          {/* Form */}
          <Formik
            initialValues={{ email: '', password: '' }}
            validate={(values) => {
              const errors = {};
              if (!values.email) {
                errors.email = 'Email address is required';
              } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                errors.email = 'Please enter a valid email';
              }
              if (!values.password) {
                errors.password = 'Password is required';
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              dispatch({ type: SIGN_IN_REQUEST, payload: values });
              setSubmitting(false);
            }}
          >
            {({ values, errors, touched, handleSubmit, handleChange, handleBlur, isSubmitting }) => (
              <form onSubmit={handleSubmit} className="login-card__form">
                {/* Email */}
                <div className="login-field">
                  <label className="login-field__label" htmlFor="login-email">Email Address</label>
                  <div className="login-field__input-wrap">
                    <IconMail size={18} className="login-field__icon" />
                    <input
                      id="login-email"
                      type="email"
                      name="email"
                      placeholder="you@company.com"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      autoComplete="email"
                      className={`login-field__input ${errors.email && touched.email ? 'login-field__input--error' : ''}`}
                    />
                  </div>
                  {errors.email && touched.email && <span className="login-field__error">{errors.email}</span>}
                </div>

                {/* Password */}
                <div className="login-field">
                  <label className="login-field__label" htmlFor="login-password">Password</label>
                  <div className="login-field__input-wrap">
                    <IconLock size={18} className="login-field__icon" />
                    <input
                      id="login-password"
                      type={showPassword ? 'text' : 'password'}
                      name="password"
                      placeholder="Enter your password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                      autoComplete="current-password"
                      className={`login-field__input ${errors.password && touched.password ? 'login-field__input--error' : ''}`}
                    />
                    <button
                      type="button"
                      className="login-field__toggle"
                      onClick={() => setShowPassword(!showPassword)}
                      tabIndex={-1}
                      aria-label="Toggle password visibility"
                    >
                      {showPassword ? <IconEye size={18} /> : <IconEyeOff size={18} />}
                    </button>
                  </div>
                  {errors.password && touched.password && <span className="login-field__error">{errors.password}</span>}
                </div>

                {/* Forgot */}
                <div className="login-card__forgot">
                  <Link to="/forgotPassword">Forgot Password?</Link>
                </div>

                {/* Error Message */}
                {authError && (
                  <div className="alert alert-danger py-2 mb-3" style={{ fontSize: '13px' }}>
                    {typeof authError === 'string' ? authError : 'Invalid email or password'}
                  </div>
                )}

                {/* Submit */}
                <button type="submit" className="login-card__btn" disabled={isSubmitting}>
                  {isSubmitting ? 'Signing in…' : 'Sign In'}
                </button>
              </form>
            )}
          </Formik>

          <p className="login-card__footer">
            &copy; {new Date().getFullYear()} SiteSync &middot; All rights reserved
          </p>
        </div>
      </div>
    </div>
  );
};

export default withAuth(Login);
